import { createContext, useContext } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';

type ClerkUser = ReturnType<typeof useUser>['user'];

interface AuthContextValue {
  user: ClerkUser;
  isLoaded: boolean;
  getToken: () => Promise<string | null>;
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { isLoaded: authLoaded, getToken } = useAuth();
  const { isLoaded: userLoaded, user } = useUser();

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoaded: authLoaded && userLoaded,
        getToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuthContext must be used within AuthProvider');
  return ctx;
}
